export const MESSAGE_STATUS_DELIVERED = "delivered";
export const MESSAGE_STATUS_READED = "readed";